/**
 * Group a battle's artists into two sides.
 *
 * - Uses each artist's `side` (1|2) when present (2v2-aware).
 * - Falls back to splitting the list in half for legacy rows without a side,
 *   so a 1v1 battle becomes one artist per side exactly as before.
 *
 * Kept dependency-free (no API/axios import) so presentational components can
 * use it without pulling the network layer into their test bundles.
 *
 * @param {Array<{id:number, display_name?:string, username?:string, side?:number}>} artists
 * @returns {Array<{side:number, artists:Array}>} always length 2 (sides 1 and 2)
 */
export const buildSides = (artists = []) => {
  const hasExplicit = artists.some((a) => a.side === 1 || a.side === 2);
  if (hasExplicit) {
    return [1, 2].map((side) => ({
      side,
      artists: artists.filter((a) => a.side === side),
    }));
  }
  const half = Math.ceil(artists.length / 2);
  return [
    { side: 1, artists: artists.slice(0, half) },
    { side: 2, artists: artists.slice(half) },
  ];
};

export default buildSides;
